module.exports = __webpack_public_path__ + "img/zs19.eed553f4.jpg";